import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import {
    RestoreUnifiedGroupJsonResponse,
    UnifiedGroupIdentity,
    UnifiedGroupIdentityType,
    getServiceAsync,
} from '../../../../service';
import { runOwsRequestWithMonitor, Feature, fullResponseOperationOption } from '../../../../shared';
import type RequestOptions from 'owa-service/lib/RequestOptions';

const HEADER_EXPLICIT_LOGON_USER: string = 'X-OWA-ExplicitLogonUser';
const HEADER_ANCHOR_MAILBOX: string = 'X-AnchorMailbox';

export function createRestoreGroupStateRequest(
    groupId: string,
    groupSmtp: string,
    routingKey: string
): Promise<RestoreUnifiedGroupJsonResponse> {
    let groupIdentity: UnifiedGroupIdentity;
    if (groupId) {
        groupIdentity = {
            Type: UnifiedGroupIdentityType.ExternalDirectoryObjectId,
            Value: groupId,
        };
    } else {
        groupIdentity = {
            Type: UnifiedGroupIdentityType.SmtpAddress,
            Value: groupSmtp,
        };
    }

    return getServiceAsync().then(service =>
        service.Operation.restoreUnifiedGroupOperation(
            {
                Header: getJsonRequestHeader(),
                Body: service.Factory.restoreUnifiedGroupRequest({
                    GroupIdentity: groupIdentity,
                }),
            },
            getRestoreGroupRequestHeaders(groupSmtp, routingKey)
        )
    );
}

export default function restoreGroup(
    groupId: string,
    groupSmtp: string,
    routingKey: string
): Promise<RestoreUnifiedGroupJsonResponse> {
    return runOwsRequestWithMonitor({
        scenarioName: 'RestoreUnifiedGroup',
        feature: Feature.UnifiedGroups,
        operation: () => createRestoreGroupStateRequest(groupId, groupSmtp, routingKey),
        transformResponse: (owsResponse: RestoreUnifiedGroupJsonResponse) => owsResponse,
    });
}

function getRestoreGroupRequestHeaders(groupSmtp: string, routingKey: string): RequestOptions {
    return {
        headers: <any>{
            [HEADER_EXPLICIT_LOGON_USER]: groupSmtp,
            [HEADER_ANCHOR_MAILBOX]: routingKey,
        },
        ...fullResponseOperationOption,
    };
}
